import * as React from 'react';
import * as _ from 'lodash-es';
import cx from 'classnames';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TravelPolicyTableRows from './TravelPolicyTableRows';
import Loader from 'components/Loader/Loader';
import { TravelPolicyTabTypes } from 'components/UserDetails/UserDetail';

const styles = require('./styles.pcss');

type Props = {
  product: TravelPolicyTabTypes;
  flightPolicy: any;
  hotelPolicy: any;
  carPolicy: any;
  isLoading: any;
};

const advanceBooking: any = {
  name: 'Advance Booking',
  description:
    'Number of days in advance a booking must be made to be considered in policy.',
};

const hardCap: any = {
  name: 'Hard Cap',
  description: 'Maximum amount a booking can be to be considered in policy.',
};

const flexibility: any = {
  name: 'Flexibility',
  description:
    'Percentage or dollar amount budget flexibility. It does not apply when hard cap is set.',
};

const refundability: any = {
  name: 'Refundability',
  description: 'Type of flights users are allowed to book without approval.',
};

class BookingRules extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  onFormatAdvancedBooking(val: string | undefined) {
    if (val === '' || !val) {
      return '-';
    }

    return val + ' Days';
  }

  onFormatOverBudget(val: string | undefined) {
    if (val === '' || !val) {
      return '-';
    }

    return `$${val}`;
  }

  onFormatFlexValue(val: string | undefined, valueType: string | undefined) {
    if (val === '' || !val) {
      return '-';
    }

    if (valueType === 'percentage') {
      return `${val}%`;
    }

    return `$${val}`;
  }

  onFormatRefundabilityValue(selected: string | undefined) {
    if (!selected) {
      return '-';
    }

    if (selected === 'nonRefundable') {
      return 'Non-Refundable';
    }

    return selected;
  }

  render() {
    const {
      isLoading,
      product,
      flightPolicy = {},
      hotelPolicy = {},
      carPolicy = {},
    } = this.props;

    let flightAdvanceBooking,
      hotelAdvanceBooking,
      carAdvanceBooking,
      flightOverBudget,
      hotelOverBudget,
      carOverBudget,
      flightFlex,
      hotelFlex,
      carFlex,
      flightRefundability;

    flightAdvanceBooking = this.onFormatAdvancedBooking(
      flightPolicy?.daysInAdvance?.value,
    );
    hotelAdvanceBooking = this.onFormatAdvancedBooking(
      hotelPolicy?.daysInAdvance?.value,
    );
    carAdvanceBooking = this.onFormatAdvancedBooking(
      carPolicy?.daysInAdvance?.value,
    );

    flightOverBudget = this.onFormatOverBudget(flightPolicy?.overValue?.value);
    hotelOverBudget = this.onFormatOverBudget(hotelPolicy?.overValue?.value);
    carOverBudget = this.onFormatOverBudget(carPolicy?.overValue?.value);

    flightFlex = this.onFormatFlexValue(
      flightPolicy?.overBudgetFlex?.value,
      flightPolicy?.overBudgetFlex?.valueType,
    );
    hotelFlex = this.onFormatFlexValue(
      hotelPolicy?.overBudgetFlex?.value,
      hotelPolicy?.overBudgetFlex?.valueType,
    );
    carFlex = this.onFormatFlexValue(
      carPolicy?.overBudgetFlex?.value,
      carPolicy?.overBudgetFlex?.valueType,
    );

    flightRefundability = this.onFormatRefundabilityValue(
      flightPolicy?.refundability?.selected,
    );

    return (
      <Paper
        className={isLoading ? cx(styles.paper, styles.loading) : styles.paper}
      >
        <div className={styles.policyRules}>
          <h2>Booking Rules</h2>
          <div>
            <Loader visible={isLoading} />
          </div>
          <Table>
            <TableBody>
              <TravelPolicyTableRows
                key={1}
                product={product}
                text={advanceBooking}
                flight={flightAdvanceBooking}
                hotel={hotelAdvanceBooking}
                car={carAdvanceBooking}
              />
              <TravelPolicyTableRows
                key={2}
                product={product}
                text={hardCap}
                flight={flightOverBudget}
                hotel={hotelOverBudget}
                car={carOverBudget}
              />
              <TravelPolicyTableRows
                key={3}
                product={product}
                text={flexibility}
                flight={flightFlex}
                hotel={hotelFlex}
                car={carFlex}
              />
              {product === TravelPolicyTabTypes.flight && (
                <TravelPolicyTableRows
                  key={4}
                  text={refundability}
                  product={product}
                  flight={flightRefundability}
                />
              )}
            </TableBody>
          </Table>
        </div>
      </Paper>
    );
  }
}

export default BookingRules;
